import React from 'react';
import { FaBook } from "react-icons/fa";
import { GiRuleBook } from "react-icons/gi";
import './rules.css'; // Import the CSS file

const Rules = () => {
    return (
        <div className='container-fluid'>
            <h1 className="header-h1"style={{ color: '#0353a4', marginTop: '85px', textAlign: 'left' }}>
                <FaBook /> Rules
            </h1>
            <hr style={{ marginBottom: '10px' }} />
            <h1 className="header-h1" style={{ color: '#0353a4', textAlign: 'left', marginTop: '20px' }}>
                <GiRuleBook style={{ marginRight: '8px' }} /> HIRA DENTAL LAB Rules
            </h1>
            <hr style={{ marginBottom: '10px' }} />
            <div className="rules-content">
                <h4 style={{ textAlign: 'center', marginTop: '20px', fontWeight: 'bold' }}>Hira Tech working Rules</h4>
                <hr style={{ marginLeft: '400px', marginRight: '400px', marginTop: '10px', marginBottom: '5px' }} />
                <h4 style={{ textAlign: 'left', fontWeight: 'bold' }}>
                    Book In Rules
                </h4>
                <h6 style={{fontSize:'bold'}}>
                    We need to write in the notes which type of implant connection it is and it should be printed on the lab work ticket when you book in.
                </h6>
                <p className="rules-text">
                    • Hampton Dental is a private surgery. Please make sure it's booked as a private job.<br />
                    • Jobs from myitero or any other website that contains notes from a dentist should be mentioned on the next page while booking.<br />
                    • All postage jobs should be booked one/two days before the given date.<br />
                    • Smop jobs for Nick Gibb/Hari Hunjun should always be booked under Hari Hunjan's account.<br />
                    • We should follow the notes given by the dentist not RX file.<br />
                    • If the dentist mentioned an appointment date, we will book in one/two days before the given date.<br />
                    • Should be confirmed with first and last name that no jobs have been booked twice.<br />
                    • If we receive the job after 12.00 o'clock (UK time), we will book in for the day after tomorrow (for urgent job).<br />
                    • If the job we received is from a new surgery, we will add it first and then book in.<br />
                    • All implant jobs which we received from Coventry Road Dental should be booked under Gurtaran Shergill.<br />
                    • First case of New surgery should be free of charge.<br />
                    • All Hampton house jobs should be booked as a Private job.<br />
                    • All Smop jobs for Bhandal should be booked under Chetan Mathias's account.
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                    Daily Checklist
                </h4>
                <p className="rules-text">
                    • We should check 2 previous jobs at my ITERO+3SHAPE+CS CONNECT on a daily basis. They should mention the time when we checked them.<br />
                    • We should check updates from the LabNEXT dashboard on a daily basis and should mention the time when we check them.<br />
                    • MY ITERO: Jobs From (00-06-2021 To 00-06-2021) checked at (DD-MM-YYYY)<br />
                    • 3SHAPE: Jobs from (00-06-2021 To 00-06-2021) checked at (DD-MM-YYYY)<br />
                    • CS Connect: Jobs from (00-06-2021 To 00-06-2021) Checked at (DD-MM-YYYY)<br />
                    • Checked at (DD-MM-YYYY) for LAB NEXT updates
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Post Surgeries
                </h4>
                <p className="rules-text">
                1 • Roseville House<br/>
                2 • Nothing But The Tooth <br/>
                3 • Holloway House <br/>
                4 • Ascent Dental   TAMWORTH DENTAL<br/>
                5 • Craige Dental  (Private Practice)<br/>
                6 • All Saints Dental <br/>
                7 • Altmore Dental Practice<br/>=
                8 • Solihull<br/>
                9 • Smile Solution<br/>
                10 • Langley Dental <br/>
11 • Village Dental Surgery<br/>
12 • Teeth & Face Ltd<br/>
13 • Delapre Dental Care Clinic<br/> 
14 • Bankton Dental Practice<br/>
15 • Blaby Dental Practice<br/>
16 • Brighter Smile Dental<br/>
17 • Alan Burgin<br/>
18 • Arminder Sohal ( 111 Sandwell Road )<br/>
19 • Damira Bridge Street Dental Practice<br/>
20 • Daniel Leonelli ( Swissmeda )<br/>
21 • Dental Beauty (Greenhithe)<br/>
22 • Faezeh Ghaffari ( West Health Dental )<br/>
23 • Fogg & Whittingham Surgery<br/>
24 • Fosse Dental Care<br/>
25 • Glen Parva Dental Practice<br/>
26 • Grandholm Dental Clinic<br/>
27 • Hampton House Dental Practice<br/>
28 • Karim Patel ( Great Harwood )<br/>
29 • Lansdown Dental Practice<br/>
30 • Laurel Dental Practice<br/>
31 • Mitton Dental Surgery <br/>
32 • Mydentist Hinckley<br/>
33 • Oxon Dental Care<br/>
34 • Paddox Dental Practice<br/>
35 • Park View Dental Care<br/>
36 • Parkview Dental Care ( SG6 1NY )<br/>
37 • Seven Hills Dental Practice<br/>
38 • Smilecare Dental Practice<br/>
39 • South Wilts Implant Centre<br/>
40 • Southbank Sedation And Implant Centre<br/>
41 • Splendental Care<br/>
42 • Stallion Assets Ltd<br/>
43 • Station House Dental Practice<br/>
44 • Synergy Birmingham<br/>
45 • The Melton Clinic<br/>
46 • The Priors Dental Practice<br/>
47 • Tiverton Dental Centre<br/>
48 • Toothcare Dental<br/>
49 • Whyte House Dental Surgery<br/>
50 • Winn Dental Labortory
</p>

                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                PAN COLOUR
                </h4>
                <p className="rules-text">
                These are the main ones Pan Colours<br/>
• GREEN       PK side jobs<br/>
• PURPLE      Retainers<br/>
• ORANGE     Crown and Bridge<br/>
• LIME        Urgent Jobs<br/>
• PINK         Smop guide<br/>
Bookin Update<br/>
• If we have to make Upper and Lower Crowns (Both Arch) need to create 2 separate jobs for each jaw for scanning.<br/>
• Always book in the jobs with the patient's name or patient ID and both if available. If both are not mentioned then we will confirm with the dentist.<br/>
Rules For Crown & Bridges
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                DESIGNING DIGITAL JOBS
                </h4>
                <p className="rules-text">
                • In digital jobs designer should have to know for what the job bookin. <br/>
• Make sure it would be right booked.<br/>
• Make sure all procedure are correct.<br/>
• All notes and instructions from dentist should be follow.<br/>
• Check the scan that should be accurate.<br/>
• In case of any incorrect scan or missing scan, designer or bookin person will inform dentist accordingly.<br/>
• An attachment bar must be applied for support if the implant model or bridge in U shape. (29-04-2023)<br/>
• In full arch case plan first what we have to design bar or bridge on tie base, and inform dentist about this.<br/>
• Don't trim the model. Always for sport guards we need a full model. (14-06-2023)<br/>
• Always take picture leave note on Labnext about instructions or upload picture on labnext.
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                SIMPLE CROWN AND BRIDGE
                </h4>
                <p className="rules-text">
                • Simple crown and bridges are design in multilayerd zirconia.<br/>
• Cement gap for crown starts from margin is 0 mm and end on 0.09 mm.<br/>
• In complex prep stars from 0 mm and end on 0.17 mm or more according to undercuts.<br/>
• Insertion direction of simple crown will be according to prep and in more than one crown in a job insertion direction will be unique.<br/>
• In bridges cement gap from margin should be 0.0 mm and ends 0.17 mm and vary in different undercuts situation.<br/>
• Proximity in crown and bridge: From occlusssion 1.3 mm.<br/>
• Always use disc cutter in cutintersection.<br/>
• Always use articulator in posterior cases and in bridge design.<br/>
• Mrayland bridge: Metal maryland wing with 0.5 mm thickness.<br/>
• In zirconia maryland wing with 0.8 mm.<br/>
• Never make private maryland in zirconia unless dentist request for zirconia.<br/>
• If you have om1, om2, or bleach shade makes them offset coping a layer in the lab will be applied and mill HT multilayer.<br/>
• Please use a proximally disk cutter also have for every single crown. (11-08-2023)
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                VENEERS AND INLAY / ONLAY 
                </h4>
                <p className="rules-text">
                • In the design of inlay/onlay minimal thickness should be 0.5mm.<br/>
• In lap around veneer (mesial, distal/incisal edge invove),select veneers as crown.<br/>
• Insertion direction for wrapaparound veneers select as crown, But in simple veneer select labially on 45°degree<br/>
• wrapaparound veneer will mill as crown strategy otherwise use veneer strategy.<br/>
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                METAL CROWNS
                </h4>
                <p className="rules-text">
                • Metal crown will be design on dentist instructions. We do not make metal crowns in NHS . Inform the dentist about this on the other side. Private cases may design in precious gold or in NP metal crowns.<br/>
                • Emax crown always send to skill bond. Increase the marginal thickness in Emax crown and veneers. Minimal thickness will increase in Emax crown that is 0.6 mm to 0.7 mm .
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Rules For Implant Crown And Bridges
                </h4>
                <p className="rules-text">
                The Implant cases will design the implant crown according to dentist instructions.<br/>

1.Chetan Mithias: This dentist always use Camlog and conelog implant system. We will design crown on tie-base and bridge on bar, screw channel on labial side or deep implant will make titanium custom abutment with angle correction. We will send screw driver to dentist if he required. Cement gap on titanium custom abutment would be 0.03 mm. It would be 0 mm from margins. In some cases Chetan mithias use sweden and martina prama connection but in rare. camlog, conlog and Neoss have three flat surfaces. These refer the triangular connection. These connections are different from other conection. If you can't see the third surface using ladder step, Please do not proceed. Request dentist to locate where is the ledder step?<br/>
2.Farooq Ahmad: This dentist always use sweden and martina prama conection. Supragingival placement.When we design his job, We will go below margins.Parameters for below margin are: Radius of bottom will be 0.425 mm and 0.5 mm thick from margin.In some cases, Farooq ahmad use Neoss implants. In that case we will design models first than will desing crown on scan ti-base. This will called manual retained or without scan body scan crown. In this crown insertion direction would be as defined as implant already has.Do not use unique insertion direction in manual retained crowns.In scan ti base cement gap would be 0.02 mm and 0 mm from margins.<br/>
3. Hamid Alvi: This dentist always used NEODENT GM implant connection. In this case designer always make titanium abutments with screw retained crown.In bridges we will design bars.<br/>
4. Arminder Sohal: This dentist always use conlog conection, full arch case dentist used southren multi-units.Hira Tech have already design the multi-units library, please use Hira Tech in full arch temporary bridges but in bar design we will use disc library from hoil.<br/>
5. Ajith Georg: This dentist use BIOmet 3i Certain connection or Biohorizon internal connect. In this case we use Hira Tech connection.<br/>
6. Justin George: Use Biohorizen internal connection.<br/>
7. Murry Dental (Devid wolverson): This is new dentist use Straumann NC, RC connection (original).<br/>
8. Vineeth Balachandran: Use Adin touarege swel but we will use Hira Tech.<br/>
9. Nick Gibb: Biomet 3i certain and Biohorizen internal.<br/>
10.Gurtaran Shargill: Southren external hex.We do immediate replacement of implant bridge of this dentist. In that case we should have CBCT before surgery and after surgery. Screw from southern have to be order before.we will design case on scan body scan align on CBCT scan. This bridge will print in flexcera.<br/>
11. Tanzeem Raees: This dentist used Osstem connection.<br/>
12. Hassan Kamal: Osstem Hira Tech<br/>
13. Parvis: Osstem Original<br/>
14. Arshad Mahmood: Dentium SuperLine<br/>
15. Hiren Yagnik: Sweden Martina Prama Hira Tech<br/>
16. Until we resolved the error in the machine. Please add Adjustment 0.18 in the implant crowns or bridges and placed inside the zirconia disc from center to the right side. (18-07-2023)
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Rules For Titanium Bar And Substructure Bridge
                </h4>
                <p className="rules-text">
                Titanium bar design in full arch cases with acrylic wrapround or zirconia substructure. Will design FP1 , FP2 and FP3 according to situation. Cement gap for acrylic wrapround undercut do not allow angle should be 1.87 mm .In zirconia substructure gap would according to undercut starts from 0 mm and up to 0.17 mm. When we design bar give 1 mm pressure on gingiva under the bar.
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Emax veneers and Crown Parameters
                </h4>
                <p className="rules-text">
                • Angle 60<br/>
• Horizontal crown margin    0.2mm<br/>
• Angle crowm margin  0.2mm<br/>
• Gap width of cement 0.08mm<br/>
• Don't block out 0<br/>
• In veneers, we will  shorten the margin in the mesial and distal when the contact point merged together. 
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Rules For Printing
                </h4>
                <p className="rules-text">
                • Each print file must be checked in separately.<br/>
•Tomorrow's file from the Magna printer has to be deleted as soon as it comes in the morning.<br/>
• Before Placing The Print, Consider These Factors: We have the ability to print in E Model Light, Implant Models, Private Stl Models, Smop Job, Models and Diagnostic Wax-up Models.<br/>
• All upper and lower denture models + All antagonist models should be printed.<br/>
• In the magna printer (Dental Model Beige)-(100 MIC)<br/>
• Please write the patient's name, Hira Lab, and date on the models.<br/>
• Hole design instructions: Which job we have to print bridge screw hole should be prepared,while in milled bridge we just creat hole mark on it.<br/>
Rules For Implant System<br/>
• Nobal analog and screw compatible are with BT-K multiunit (29-04-2023)<br/>
• Astra Tech compatible is with the Southern Implant (05-05-2023)<br/>
• Full bridges should always be printed with an attachment bar. (11-10-2023)<br/>
• All try in bridges should be printed in e model light unless specified. (11-10-2023)<br/> 
• All temporary bridges should be printed in flexcera unless specified. (11-10-2023)
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Rules For Milling
                </h4>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Shade Guide For Milling
                </h4>
                <p className="rules-text">
                • When we receive a case for milling, first of all we have to read the lab ticket for instructions and shade confirmation.We also need to check the crown or bridge which is going to mill is designed according to provided instructions from dentist following are the key points we keep in mind while milling<br/>
• Should be milled in exact shade •No one in the milling software will delete the disc on their own free will, if someone deletes the disc, he will be heavily fined and will also write in his work.<br/>
• Any private work you do in stronger zirconia should be reduced labially (Anterior only)<br/>
• Never reduce NH's crowns and bridges (Anterior and Posteriors)<br/>
• Read all notes and lab tickets before milling. And commit in notes (Lab Tickets And Notes Read)<br/>
• A1 = B1, C1, D2, A1.5<br/>
• A3 = A2, A4, B3, B4, B2, D3, D4<br/>
• C3 = C2, C3, C4 • O2 = A3, A2<br/>
• O3 = A3<br/>
• 2B.210 = A3<br/>
• Angle correction implant crowns and bridges should be mill through Angle correction strategy. (12-06-2023)<br/>
• Shade VC A3.5 will always mill in Shade VC A4. (02-06-2023)<br/>
• ARGEN ST 900 MPA ARGEN HT 1100 MPA<br/>
• HS 1400 MPA<br/>
• Please check the insertion direction of every case. When you place crowns and bridges in disc.This should be charged every person who do not follow the rule.<br/>
• At Uk side <br/>
Left side (problem) adjustment= -0.18<br/>
Right side=normal adjustment = -0.05<br/>
• At Pak side<br/>
Right side (problem) adjustment= -0.18<br/>
Left side=normal adjustment = -0.05 (18-07-2023)<br/>
• Please use the Angle correction Strategy for all implant bridges. (25-07-2023)
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Correction Factor For 364 Machine
                </h4>
                <p className="rules-text">
                • Original strauman with four groves + Synocta ( - 0.08 )<br/>
• Southern IMP Library: ( -0.08 ) • Most IMP (Hoil Connection) : ( -0.06 ),(For temporary Basis)<br/>
• Implant Bridge : ( -0.16 )<br/>
• Abutment : ( -0.04 )<br/>
• Scanned Tie-Base ( Manual Retained) : ( -0.01 )<br/>
• Hira Osstem   ( - 0.095 )<br/>
• Hira Library For Bridge And Crown (- 0.02)<br/>
• Hira Library ( Z ) Allowance (- 0.08)<br/>
• Bio Met Imp ( Hira Library ) (XY) Allowance (- 0.095)<br/>
• Bio Met Imp ( Hira Library ) ( Z ) Allowance  (- 0.095)<br/>
• Sweden Martina Prama (- 0.02)<br/>
• E Los ( XY ) Allowance (- 0.03)<br/>
• Biohorizon Imp (Hira Tech) (- 0.04)<br/>
• Adin Touareg (Hira Tech) (- 0.06)<br/>
• Hira Tech Osstem (- 0.03)
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Liquid Crystal Magna Dental Model Beige (100 um)
                </h4>
                <p className="rules-text">
                1) Add no supports to the lower models or the models which have no plate<br/>
2) Add single supports on the plate surface only.Of the models which have the plate like (study models, upper denture models)
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Dental Large Models Parameters ( Parameter Changed By (MR_001)
                </h4>
                <p className="rules-text">
                • Density 40%<br/>
• Tip Diameter 0.85 ( MM )<br/>
• Pole Diameter 1.5 ( MM )<br/>
• Height of Foot 1.0 ( MM )<br/>
• Pole Widening Factor 2.0<br/>
• Place Above Base At 0.0 ( MM )<br/>
• Add no internal supports if length is smaller than 10.0 ( MM )<br/>
Part Connection<br/>
• Tip Beam Diameter 1.2 ( MM )<br/>
• Tip Contact Depth 0.1 ( MM )
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Advance Setting                </h4>
                <p className="rules-text">
                • Creast Offset 0.5 ( MM )<br/>
• Thickness Multiplier Top Joint 1.0 ( MM )<br/>
• Length Of The First Beam 4.0 ( MM )
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                Base Plate       </h4>
                <p className="rules-text">
                • Diameter At The Top Of The Foot 6.0 ( MM )<br/>
• Diameter At The Bottom Of The Foot 5.5 ( MM )
                </p>
                <h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
                E Guide    </h4>
                <p className="rules-text">• Tip Thickness 0.80 MM<br/>
• Beam Thickness 1.60 MM<br/>
• Beam Spacing 1.80 MM <br/>
• Min Support Height 5.00 MM</p>
<h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
E Model Light</h4>
                <p className="rules-text">• Tip Thickness 0.70 MM<br/>
• Beam Thickness 1.40 MM<br/>
• Beam Spacing 4.00 MM<br/>
• Min Support Height 4.00 MM</p>
<h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
Rules for placing order </h4>
                <p className="rules-text">• Orders must be placed before 2:00 PM on the UK side. And it has to be delivered at 2:00 pm the next day. If not, we will call the company. (17-07-2023)

</p>
<h4 style={{ textAlign: 'left', fontWeight: 'bold', marginTop: '3px' }}>
Serious Mistakes Fine Rule

 </h4>
                <p className="rules-text">The person who will involve in serious mistake or blunder, will charge fine of 500/- rupees per mistake. He or Her will be write her mistake in His or Her daily work report and in monthly work report.

</p>


            </div>
        </div>
    );
};

export default Rules;
